precision highp float;

uniform sampler2D uTexture;

varying vec2 vPUv;
varying vec2 vUv;

void main() {
	vec4 color = vec4(0.0);
	vec2 uv = vUv;
	vec2 puv = vPUv;
    vec4 colorA = vec4(0.8, 0.89, 0.98, 1.0);
	float distance = 0.5 - distance(uv, vec2(0.5));
	float t = smoothstep(0.0, 0.3, distance);
	color = colorA;
	color.a = t;

	gl_FragColor = color;
}